export type MobergThemeColors = {
	main: string
	hover: string
	active: string
	noFill: {
		hover: string
		active: string
	},
	link: {
		main: string
	}
	text?: string
}

export interface MobergThemeData {
	[theme: string]: MobergThemeColors
}

export enum MobergTheme {
	GREEN = "green",
	BLUE = "blue",
	RED = "red",
	BLACK = "black",
	GRAY = "gray",
	WHITE = "white",
	WARNING = "warning",
	MEDIUM_GRAY = "medium_gray",
	ON_LIGHT_BLUE = "on_light_blue", // Where the background is hover blue, not active blue
	ON_BLUE = "on_blue", // A theme for elements where the background is blue
	ON_GRAY = "on_gray",
	ORANGE = "orange",
}

const themeData: MobergThemeData = Object.freeze({
	green: {
		main: "#008000",
		hover: "#006600",
		active: "#004D00",
		noFill: {
			hover: "#E6F2E6",
			active: "#CCE6CC",
		},
		link: {
			main: "#008000"
		}
	},
	black: {
		main: "#222",
		hover: "#444",
		active: "#666",
		noFill: {
			hover: "#edf2f7",
			active: "#e2e8f0",
		},
		link: {
			main: "#222"
		}
	},
	gray: {
		main: "#CDCDCD",
		hover: "#DEDEDE",
		active: "#ABABAB",
		noFill: {
			hover: "#EFEFEF",
			active: "#DEDEDE",
		},
		link: {
			main: "#CDCDCD"
		}
	},
	blue: {
		main: "#207dea",
		hover: "#1966BE",
		active: "#1658a4",
		noFill: {
			hover: "#EBF8FF",
			active: "#BEE3F8",
		},
		link: {
			main: "#0097EE"
		}
	},
	red: {
		main: "#e64e58",
		hover: "#C53030",
		active: "#9B2C2C",
		noFill: {
			hover: "#FFF5F5",
			active: "#FED7D7",
		},
		link: {
			main: "#e64e58"
		}
	},
	on_blue: {
		main: "",
		hover: "",
		active: "",
		noFill: {
			hover: "#A4CCE1",
			active: "#92B5C8",
		},
		link: {
			main: "#c4c4c4"
		}
	},
	on_light_blue: {
		main: "",
		hover: "",
		active: "",
		noFill: {
			hover: "#D6E8F2",
			active: "#BDDAEA",
		},
		link: {
			main: "#c4c4c4"
		}
	},
	on_gray: {
		main: "",
		hover: "",
		active: "",
		noFill: {
			hover: "#D6DADF",
			active: "#BEC2C6",
		},
		link: {
			main: "#c4c4c4"
		}
	},
	white: {
		main: "#fff",
		hover: "#f8f9fa",
		active: "#e9ecef",
		noFill: {
			hover: "#f8f9fa",
			active: "#e9ecef",
		},
		link: {
			main: "#fff"
		}
	},
	medium_gray: {
		main: "#888",
		hover: "#999",
		active: "#777",
		noFill: {
			hover: "#f5f5f5",
			active: "#e8e8e8",
		},
		link: {
			main: "#888"
		}
	},
	[MobergTheme.WARNING]: {
		main: "#E2A03F",
		hover: "#C78A2F",
		active: "#aa6f17",
		noFill: {
			hover: "#FFF2D5",
			active: "#FFE3A8",
		},
		link: {
			main: "#E8AF4C",
		},
	},
	orange: {
		main: "#F97316",
		hover: "#EA580C",
		active: "#C2410C",
		noFill: {
			hover: "#FFF7ED",
			active: "#FFEDD5",
		},
		link: {
			main: "#F97316"
		}
	},
})

export const getColors = (theme: MobergTheme): MobergThemeColors => {
	// Maybe we will have other things besides color?
	return themeData[theme]
}
